"use client";
import { colorResolver, textColorResolver } from "./color-resolver/color-resolver.mjs";
import { borderResolver } from "./border-resolver/border-resolver.mjs";
import { fontFamilyResolver } from "./font-family-resolver/font-family-resolver.mjs";
import { fontSizeResolver } from "./font-size-resolver/font-size-resolver.mjs";
import { identityResolver } from "./identity-resolver/identity-resolver.mjs";
import { lineHeightResolver } from "./line-height-resolver/line-height-resolver.mjs";
import { radiusResolver } from "./radius-resolver/radius-resolver.mjs";
import { sizeResolver } from "./size-resolver/size-resolver.mjs";
import { spacingResolver } from "./spacing-resolver/spacing-resolver.mjs";
//#region packages/@mantine/core/src/core/Box/style-props/resolvers/index.ts
const resolvers = {
	color: colorResolver,
	textColor: textColorResolver,
	fontSize: fontSizeResolver,
	spacing: spacingResolver,
	radius: radiusResolver,
	identity: identityResolver,
	size: sizeResolver,
	lineHeight: lineHeightResolver,
	fontFamily: fontFamilyResolver,
	border: borderResolver
};
//#endregion
export { resolvers };

//# sourceMappingURL=index.mjs.map